
window.SMTX.CanvasVideo = (function () {

  if ($('[data-replace-video-with-canvas]').length < 0) {
    return false;
  }

// Toggle this boolean to hide/show the original video alongside the canvas version of the video.
var hideOrig = false;

// draws the current frame from the video, then sets a timeout to do it again (roughly 30 FPS).
var drawFrame = function(v,c) {
  if (v.paused || v.ended) return false;
  var w = v.videoWidth;
  var h = v.videoHeight;
  c.canvas.width = w;
  c.canvas.height = h;
  c.drawImage(v,0,0,w,h);
  v.timeout = setTimeout(drawFrame, 30, v,c);
}

// creates a canvas element, inserts it, and begins drawing video frames
document.querySelectorAll('[data-replace-video-with-canvas]').forEach(function(v) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  v.parentNode.appendChild(canvas);
  if (hideOrig) v.classList.add('shy');

  drawFrame(v,ctx);

  v.addEventListener('playing', function() {
    if (typeof v.timeout === 'number') clearTimeout(v.timeout);
    drawFrame(this,ctx);
  });
});
  return {

  };

})();